import { Props } from './types';

export const arePropsEqual = (prevProps: Props, nextProps: Props) =>
  !!(prevProps.className === nextProps.className) &&
  !!(prevProps.altText === nextProps.altText) &&
  !!(prevProps.deviceType === nextProps.deviceType);
